import * as React from 'react';
import { connect } from 'react-redux';

import Icon from "../static/Icons";
import Modal from "../static/Modal";
import Header from '../static/Header';
import AgencyEntry from './AgencyEntry';
import {Button} from "../static/Elements";
import {AgenciesLayout} from '../static/Layouts';
import {FormInput, TextField} from "../static/Inputs";

import createLogger from '../../utils/createLogger';
import {createAgency, getAgencies} from '../../data/agencies/agenciesActions';
import {createDidError, createIsLoading} from "../../data/requests/requestsSelectors";

const DEBUG = true;
const debug = createLogger(DEBUG, `AgencyList.js`);

const mapStateToProps = (state) => {
  const didError = createDidError(AgencyList.dependencies);
  const isLoading = createIsLoading(AgencyList.dependencies);

  return {
    isAuthenticated: !!state.auth.session,
    agencies: state.agencies.agencies,
    didError: didError(state),
    isLoading: isLoading(state),
  }
};

const mapDispatchToProps = {
  getAgencies,
  createAgency,
};


class AgencyList extends React.Component {

    static dependencies = [
      `GET_AGENCIES`,
      `POST_AGENCY`,
    ];

  /* ------------ lifecycle methods ------------ */
  constructor (props) {

    super (props);
    debug.enter (`constructor`);

    this.state = {
      filterInput: '',
      modalIsOpen: false,
      domain: '',
    }
  }

  componentDidMount () {
    debug.log('in componentDidMount');
    this.props.getAgencies();
  }

  onChange = (e) => {
    e.preventDefault();
    this.setState({
      filterInput: e.target.value,
    })
  };


  onInputChange = (field) => (input) => {
    console.log (input);
    this.setState ({...this.state, [field]: input});
  };

  toggleModal = () => {
    this.setState({modalIsOpen: !this.state.modalIsOpen})
  };

  createAgency = () => {
    const agency = {domain: this.state.domain};
    this.props.createAgency(agency);
    this.toggleModal();
  };

  render () {

    const { filterInput, modalIsOpen, domain } = this.state;
    const { onInputChange, toggleModal, createAgency, onChange } = this;
    const { agencies } = this.props;

    const filterConfig = {
      type: `search`,
      value: filterInput,
      placeholder: 'Search domains',
      onChange: onChange,
      className: `filter-input`,
    };

    const domainFieldConfig = {
      value: domain,
      label: 'Agency domain',
      placeholder: 'e.g. linkedin.com',
      type: 'text',
      onChange: onInputChange('domain'),
    };

    let filteredList = agencies.filter(a =>
      a.url.indexOf(filterInput.toLowerCase())>-1
    );

    return (
      <AgenciesLayout>

        <Modal title='Add Agency'
               isOpen={modalIsOpen}
               close={toggleModal}
               closeButton>
          <div className='edit-agency-container'>
            <FormInput className='agency-fields'>
              <TextField {...domainFieldConfig}/>
            </FormInput>
            <div className='modal-footer-actions'>
              <Button primary onClick={createAgency}>
                Save
              </Button>
            </div>
          </div>
        </Modal>

        <Header top/>

        <div className='agency-list-body'>
          <div className="agency-list-header">
            <h2>Agencies</h2>
            <input {...filterConfig} />
            <Button primary onClick={toggleModal}>
              <Icon.Add/>
            </Button>
          </div>
          <div className='agency-list'>
          {
            filteredList ? (
              filteredList.map(a => (
                <AgencyEntry key={a._id} agency={a}/>
              ))
            ) : null
          }
          </div>

        </div>

      </AgenciesLayout>
    )

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgencyList);


// WEBPACK FOOTER //
// ./src/components/Agencies/AgencyList.js